import React from 'react';
import H1 from 'components/elements/h1';
// import P from 'components/elements/p'; // TODO uncomment this line when we have correct isWMG flag from BE
import useMedia from 'hooks/useMedia';
import {
  Table,
  TableWrapper,
  ChartTableWrapper,
  // WmgPercent, // TODO uncomment this line when we have correct isWMG flag from BE
  ComponentFilters,
  ToolbarMenu,
  Toolbar,
  // WmgLabel, // TODO uncomment this line when we have correct isWMG flag from BE
} from './chartTable.style';
import ChartTableHeader from './tableHeader';
import ChartTableBody from './tableBody';
import { IChartTrackData } from 'helpers/interceptors/chartsTableDataInterceptor';
import Layout from 'components/styled/Layout/Layout';
import Placeholder from 'components/data-visualization/Table/Placeholder';
import ToolbarOptions from 'components/utility/GenericComponent/ToolbarOptions/ToolbarOptions';
import { ChartTypes } from 'types/shared';

interface IChartTableProps {
  chartName: string | undefined;
  chartFrequency: string;
  tracks: IChartTrackData[];
  wmgRepresents: string | null;
  selectedCountryName: string | undefined;
  chartPage: ChartTypes;
  exportUrl: string;
  dataCy: string;
}

const ChartTable: React.FC<IChartTableProps> = (props) => {
  const {
    chartName,
    chartFrequency,
    tracks,
    selectedCountryName,
    chartPage,
    exportUrl,
    dataCy,
  } = props; // TODO add wmgRepresents prop when we have correct isWMG flag from BE

  /**
   * Media query to switch between mobile/desktop behavior
   */
  const isLargeScreen = useMedia('(min-width: 60em)');

  const hasNoData =
    !chartName || !selectedCountryName || !tracks || tracks.length === 0;

  // const WmgRepresentsElement: JSX.Element = (
  //   <>
  //     {wmgRepresents && (
  //       <P pb={2}>
  //         Warner Music Group represents{' '}
  //         <WmgPercent>{wmgRepresents} </WmgPercent>
  //         of the artists on the chart below.
  //       </P>
  //     )}
  //   </>
  // ); // TODO uncomment this part when we have correct isWMG flag from BE

  return (
    <ChartTableWrapper data-pw={dataCy}>
      {!hasNoData && (
        <>
          <Toolbar>
            <div>
              <H1 fontSize={4} my={0} marginBottom={1}>
                {chartName}
              </H1>

              {selectedCountryName && (
                <ComponentFilters>
                  Applied filters: {selectedCountryName}
                </ComponentFilters>
              )}

              {/* {WmgRepresentsElement} // TODO uncomment this part when we have correct isWMG flag from BE */}

              {/* <WmgLabel>WMG TRACK</WmgLabel> // TODO uncomment this part when we have correct isWMG flag from BE */}
            </div>

            <ToolbarMenu data-gtag="context-menu">
              <ToolbarOptions
                glossarySlug={`charts/${chartPage}`}
                extraToolbarItems={[
                  {
                    href: exportUrl,
                    label: 'Export data',
                    type: 'Export',
                    Order: 1,
                  },
                ]}
              />
            </ToolbarMenu>
          </Toolbar>

          <TableWrapper isLargeScreen={isLargeScreen}>
            <Table>
              {isLargeScreen && (
                <ChartTableHeader
                  isDaily={
                    (!!tracks && !!tracks[0].daysOnChart) ||
                    chartFrequency === 'daily'
                  }
                />
              )}
              <ChartTableBody
                tracks={tracks}
                chartName={chartName}
                isLargeScreen={isLargeScreen}
              />
            </Table>
          </TableWrapper>
        </>
      )}

      {hasNoData && (
        <Layout.Relative>
          <Placeholder
            type={'data'}
            entityType={'chart'}
            isSmallScreen={!isLargeScreen}
          />
        </Layout.Relative>
      )}
    </ChartTableWrapper>
  );
};

export default ChartTable;
